import { render, staticRenderFns } from "./doctors.vue?vue&type=template&id=68c6f461&"
import script from "./doctors.vue?vue&type=script&lang=js&"
export * from "./doctors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68c6f461')) {
      api.createRecord('68c6f461', component.options)
    } else {
      api.reload('68c6f461', component.options)
    }
    module.hot.accept("./doctors.vue?vue&type=template&id=68c6f461&", function () {
      api.rerender('68c6f461', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/robot/medical/doctor/doctors.vue"
export default component.exports